const posters = document.querySelectorAll('video.poster-lazyload');
const posterObserver = new IntersectionObserver(setPosterURL, { rootMargin: '400px', });

posters.forEach(poster => {
  posterObserver.observe(poster);
});

function setPosterURL(entries) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    
    const video = entry.target;
    const poster = video.dataset.posterUrl;
    if (poster) video.poster = poster;
    posterObserver.unobserve(video);
  });
}